import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableExtraParams } from 'projects/common/src/app/interfaces/table/table-extra-params';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ITableHeaderParams } from '../../../../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { ISummaryProductionData, ITableSummary, ITraductionModal } from '../../../../../interfaces/sp/productionbymachine';

@Component({
  selector: 'app-summary-production',
  templateUrl: './summary-production.component.html',
  styleUrls: ['./summary-production.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SummaryProductionComponent implements OnInit, AfterViewChecked {
  @Input()
  public data: ISummaryProductionData;
  @Input()
  public machineObjCode: string;

  public tableConfig: ITableConfig;

  @ViewChild('scroll', { static: true })
  public scrollContainer: ElementRef;
  public disableShadowBottom = false;
  public disableShadowTopBottom = true;
  public disableShadowTop = true;
  public widthScrollContainer = 0;
  public traductionModal: ITraductionModal;
  constructor(
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {}

  /**
   * On init component.
   */
  public ngOnInit(): void {
    this.getTraductionSummary(this.machineObjCode);
    const totalTranslation = this.languageService.message('total');
    let totalProductionQty = 0;
    let productionQtyMeters = 0;
    let headers: ITableSummary[] = this.data.productionBySectorShift.map((sector) => {
      totalProductionQty += sector.productionQty;
      productionQtyMeters += sector.productionQtyMeters;
      if (this.machineObjCode !== 'JMB') {
        return {
          sector: sector.zoneName,
          shiftname: this.languageService.message('shift', sector.shiftName),
          street: sector.streetName,
          loops: `${sector.productionQty}`,
        };
      }
      return {
        sector: sector.zoneName,
        shiftname: this.languageService.message('shift', sector.shiftName),
        street: sector.streetName,
        drillingsmts: `${sector.productionQtyMeters}`,
        drillings: `${sector.productionQty}`,
      };

      // return data;
    });
    if (this.machineObjCode !== 'JMB') {
      headers = [
        ...headers,
        {
          sector: totalTranslation,
          shiftname: ' ',
          street: ' ',
          loops: `${totalProductionQty}`,
        },
      ];
    } else {
      headers = [
        ...headers,
        {
          sector: totalTranslation,
          shiftname: ' ',
          street: ' ',
          drillingsmts: `${productionQtyMeters.toFixed(2)}`,
          loops: `${totalProductionQty}`,
        },
      ];
    }
    let customEvent = {};
    if ('drillingsmts' in this.data) {
      customEvent = {
        modal_widget: 'production-by-machine',
        tab_modal: 'production-by-machine_summary',
      };
    } else {
      customEvent = {
        modal_widget: 'production-by-machine',
        tab_modal: 'production-by-machine_summary',
      };
    }
    this.googleAnalyticsService.sendCustomEvent('modal', customEvent);
    this.setTableConfig(headers);
  }

  /**
   * After View checked
   */
  public ngAfterViewChecked(): void {
    const element = this.scrollContainer.nativeElement;
    if (element.scrollHeight > element.clientHeight) {
      this.widthScrollContainer = this.scrollContainer.nativeElement.getBoundingClientRect().width - 10;
    }
  }

  /**
   * Translate section summary
   * @param machineType
   */
  private getTraductionSummary(machineType: string): void {
    switch (machineType) {
      case 'LHD':
        this.traductionModal = {
          summary: {
            titleCardFirst: this.languageService.message('first-shelve'),
            titleCardSecond: this.languageService.message('last-shelve'),
            titleConsolidate: this.languageService.message('consolidation-shelve-shift'),
            titleHeaderTable: this.languageService.message('shelves'),
          },
        };
        break;
      case 'JMB':
        this.traductionModal = {
          summary: {
            titleCardFirst: this.languageService.message('first-drilling'),
            titleCardSecond: this.languageService.message('last-drilling'),
            titleConsolidate: this.languageService.message('consolidation-drill-shift'),
            titleHeaderTable: this.languageService.message('drilling'),
          },
        };
        break;
      case 'TRU':
        this.traductionModal = {
          summary: {
            titleCardFirst: this.languageService.message('first-loop-modal'),
            titleCardSecond: this.languageService.message('last-loop-modal'),
            titleConsolidate: this.languageService.message('consolidation-loops-shift'),
            titleHeaderTable: this.languageService.message('loops'),
          },
        };
        break;

      default:
        break;
    }
  }

  /**
   * Function to set a table by config
   */
  private setTableConfig(tableData: any[]): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      replaceColumnName: [{ prevName: 'loops', newName: this.traductionModal.summary.titleHeaderTable }],
    };

    const datasetParams: ITableDataParams = {
      tableData,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);
    const extraParams: ITableExtraParams = {
      noDataMsg: 'm019',
      disableFooter: true,
      minimalRows: tableData.length,
      quantityPerPage: tableData.length,
    };

    this.tableConfig = null;
    setTimeout(() => (this.tableConfig = { header, dataset, extraParams }), 0);
  }

  /**
   * On scroll component
   */
  public onScroll(): void {
    const element = this.scrollContainer.nativeElement;
    const atBottom = Math.floor(element.scrollHeight - element.scrollTop) === element.clientHeight;
    const atTop = element.scrollTop === 0;

    if (atTop && !atBottom) {
      this.disableShadowBottom = false;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = true;
    } else if (!atTop && !atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = true;
      this.disableShadowTopBottom = false;
    } else if (!atTop && atBottom) {
      this.disableShadowBottom = true;
      this.disableShadowTop = false;
      this.disableShadowTopBottom = true;
    }
  }
}
